export type TeamProfileTab = "overview" | "schedule" | "roster" | "activity" | "media" | "documents";

export type SchoolTeamProfileTabProps = {
  profileBackTo: string;
  schoolId: string;
  team: any;
  teamId: string;
};

export const TEAM_PROFILE_TABS: Array<{ id: TeamProfileTab; label: string }> = [
  { id: "overview", label: "Overview" },
  { id: "schedule", label: "Schedule" },
  { id: "roster", label: "Roster" },
  { id: "activity", label: "Activity" },
  { id: "media", label: "Media" },
  { id: "documents", label: "Documents" },
];

export const parseTeamProfileTab = (search: string): TeamProfileTab => {
  const tab = new URLSearchParams(search).get("tab") as TeamProfileTab | null;
  if (tab && TEAM_PROFILE_TABS.some((entry) => entry.id === tab)) {
    return tab;
  }
  return "overview";
};
